/**
 * Route of the full-screen presentation player (the shared-link entry point). Every link, router
 * registration and share URL is built from these, so the path lives in exactly one place.
 */

/** Name of the route parameter carrying the presentation id. */
export const WALLBOARD_PRESENTATION_ROUTE_PARAM = 'presentationId';

/** Router path of the presentation player (no leading slash, as `Routes` expects). */
export const WALLBOARD_PRESENTATION_ROUTE_PATH = `dashboard/wallboard/present/:${WALLBOARD_PRESENTATION_ROUTE_PARAM}`;

/**
 * Router path of a login-less shared presentation (no leading slash). Top level and outside `dashboard`:
 * the route has no guard, and nothing under `dashboard` may be reachable without signing in.
 *
 * The share token is NOT part of the path: it travels in the URL fragment (`/wallboard/shared#<token>`),
 * which the browser never sends to a server — not in the request line, not in a `Referer`, not in an
 * access log.
 */
export const WALLBOARD_SHARED_PRESENTATION_ROUTE_PATH = 'wallboard/shared';
